module.exports = __webpack_public_path__ + "img/18a001-05.7c70a0a4.png";